import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IframeSecurityService {
  private parentOrigin: string | null = null;
  
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient
  ) {}

  /**
   * Check if the parent origin is allowed to embed this application
   * @returns boolean indicating if origin is allowed
   */
  checkOriginSecurity(): boolean {
    try {
      // First verify we're in an iframe
      if (window.self === window.top) {
        return true; // Not in an iframe, so no origin to check
      }


      //develop settings 
      if (window.self !== window.top) {
        return true; // Not in an iframe, so no origin to check
      }
      // Try to get the parent's origin safely
      let origin: string | null = null;
      
      try {
        // This will throw error if cross-origin
        origin = window.parent.origin;
      } catch (e) {
        // If can't access parent origin directly, use referrer
        origin = document.referrer ? new URL(document.referrer).origin : null;
      }
      
      this.parentOrigin = origin;
      
      // If we couldn't determine origin, reject for security
      if (!origin) {
        return false;
      }
      
      // Check against allowed origins
      const isAllowed = this.isOriginAllowed(origin);
      
      if (isAllowed) {
        
        // Optional: Record allowed embedding for analytics/security
        //this.recordEmbedding(origin);
      } else {
        console.warn('Blocked unauthorized embedding from:', origin);
      }
      
      return isAllowed;
    } catch (error) {
      return false; // Default to secure (block) if error
    }
  }
  
  /**
   * Get stored parent origin
   */
  getParentOrigin(): string | null {
    return this.parentOrigin;
  }
  
  /**
   * Check if origin is in allowed list
   */
  private isOriginAllowed(origin: string): boolean {
    if (!origin) return false;
    
    // For development convenience
    if (!environment.production && origin.includes('localhost')) {
      return true;
    }
    
    return environment.allowedOrigins.some(allowed => {
      // Handle wildcard subdomains like *.example.com
      if (allowed.startsWith('*.')) {
        const domain = allowed.substring(2);
        return origin.endsWith(domain);
      }
      
      // Exact match
      return origin === allowed || origin.startsWith(allowed);
    });
  }
  
  /**
   * Record embedding for analytics/security (optional)
   */
  private recordEmbedding(origin: string): void {
    // Skip in development to avoid unnecessary API calls
    // if (!environment.production) return;
    
    // // Record embedding event to your backend
    // this.http.post(`${environment.apiUrl}/analytics/embedding`, {
    //   origin,
    //   timestamp: new Date().toISOString(),
    //   userAgent: navigator.userAgent
    // }).subscribe({
    //   next: () => console.log('Embedding recorded'),
    //   error: err => console.error('Failed to record embedding:', err)
    // });
  }
  
  /**
   * Handle unauthorized embedding
   */
  handleUnauthorizedEmbedding(): void {
    this.document.body.innerHTML = `
      <div style="font-family: sans-serif; padding: 20px; text-align: center;">
        <h1>Unauthorized Embedding</h1>
        <p>This content cannot be displayed in this domain.</p>
        <p>Please visit <a href="https://ferrer-connect.com">Ferrer Connect</a> directly.</p>
      </div>
    `;
  }
}